window.IdleTabSync = (function () {
  const CHANNEL_NAME = 'yhat-idle-sync';
  const STORAGE_KEY = 'yhat-idle-last-activity';
  const FOCUS_CHECK_INTERVAL = 5000;

  let lastActivity = Date.now();
  let channel = null;
  let onRemoteActivity = null;

  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
  } catch (_) {}

  function broadcastActivity(ts) {
    if (channel) {
      try {
        channel.postMessage({ type: 'activity', ts: ts });
      } catch (_) {}
    }

    try {
      localStorage.setItem(STORAGE_KEY, String(ts));
    } catch (_) {}
  }

  if (channel) {
    channel.onmessage = function (e) {
      if (e.data && e.data.type === 'activity') {
        lastActivity = e.data.ts;
        if (typeof onRemoteActivity === 'function') {
          onRemoteActivity();
        }
      }
    };
  }

  try {
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY && e.newValue) {
        const parsed = Number(e.newValue);
        if (!isNaN(parsed)) {
          lastActivity = parsed;
          if (typeof onRemoteActivity === 'function') {
            onRemoteActivity();
          }
        }
      }
    });
  } catch (_) {}

  function onActivity() {
    lastActivity = Date.now();
    broadcastActivity(lastActivity);
  }

  function isTabActive() {
    return !document.hidden;
  }

  function getLastActivity() {
    return lastActivity;
  }

  function setOnRemoteActivity(callback) {
    onRemoteActivity = callback;
  }

  function startFocusPolling(callback) {
    setInterval(function () {
      if (document.hidden) {
        callback();
      }
    }, FOCUS_CHECK_INTERVAL);
  }

  return { onActivity, isTabActive, getLastActivity, setOnRemoteActivity, startFocusPolling };
})();
